<div class="ppg-color-details-header-banner relative" [ngClass]="{ 'banner-with-stripe': tintsAndShades() }">
  <div
    class="flex flex-column"
    [ngClass]="{ 'header-banner-background': !!colorInfo().rgb }"
    [ngStyle]="{ '--color-details-rgb-value': hex() }">
    <div class="mt-6" [ngClass]="{ 'mb-6': !tintsAndShades() }">
      <div
        data-test-id="colorDetails.headerBanner.colorCodeContainer"
        ppgFontColorBasedOnBackground
        [backgroundRGB]="colorInfo().rgb"
        [darkFontColorValue]="'var(--fg-secondary)'"
        (fontSwitchedToLight)="onFontShadeChange($event)"
        [ngClass]="{ 'dark-font': !isFontLight(), 'light-font': isFontLight() }"
        class="flex flex-row justify-content-between">
        <p class="mt-0 flex-wrap text-lg" data-test-id="colorDetails.headerBanner.colorCodeText">
          {{ colorInfo().colorCode }}
        </p>
        @if (isFavorite()) {
          <p-button
            [text]="true"
            [icon]="PrimeIcons.HEART_FILL"
            (click)="onToggleFavoriteClick()"
            data-test-id="colorDetails.headerBanner.favoriteButton" />
        } @else {
          <p-button
            [text]="true"
            [icon]="PrimeIcons.HEART"
            (click)="onToggleFavoriteClick()"
            data-test-id="colorDetails.headerBanner.favoriteButton" />
        }
      </div>
      <h1
        ppgFontColorBasedOnBackground
        [backgroundRGB]="colorInfo().rgb"
        class="mt-0"
        data-test-id="colorDetails.headerBanner.colorName">
        {{ colorInfo().colorName }}
      </h1>

      @if (tintsAndShades()?.colors.length > 1) {
        <h2
          ppgFontColorBasedOnBackground
          [backgroundRGB]="colorInfo().rgb"
          data-test-id="colorDetails.headerBanner.tintsAndShadesHeader"
          class="tints-and-shades-header">
          {{ tintsAndShadesHeading | resourceValue }}
        </h2>
      }
    </div>
  </div>

  @if (tintsAndShades()?.colors.length > 1 && tintsAndShades(); as stripe) {
    <ppg-tints-and-shades
      class="absolute"
      data-test-id="colorDetails.headerBanner.tintsAndShadesStripe"
      [activeProductNumber]="colorInfo().productNumber"
      [stripe]="stripe"
      [colorSwitchLink]="colorSwitchLink" />
  }
</div>
